import { useClientRender } from '~/hooks/use-client-render';

import { useClientExperiment } from '../hooks/use-client-experiment';
import { useExperiment } from '../hooks/use-experiment';

export function usePricingExperimentVariant() {
  const serverVariant = useExperiment()?.topaz;
  const isClientReady = useClientRender();
  const { variant: clientVariant, isLoading } = useClientExperiment('topaz', {
    enabled: !serverVariant && isClientReady,
    pathRegex: /^\/experience$/,
  });
  return {
    variant: serverVariant ?? clientVariant ?? undefined,
    isLoading: !serverVariant && isLoading,
  };
}
